import { createSelector } from 'reselect';
import { RootState } from '../../../../types';
import { EntityTypes } from '../../../../constants/entities';
import { IKeyArray } from 'types/IKeyArray';
import { IAsset } from 'types/app/asset';
import { selectAction } from './action';
import { IActionBasic } from 'types/domain/action';
import { IEntityReducer } from 'core/reducers/entities';
import { getEntities } from 'core/selectors/utils/getEntities';

const actionId = (state: RootState, id?) => id || state.state[EntityTypes.ACTION];
const entity = (state: RootState) => state.entity.present;
const assets = (state: RootState) => state.core.assets;

export const selectActionAssets = createSelector(
  [entity, actionId, assets],
  (entity: IEntityReducer, id, assets: IKeyArray<IAsset>) => {
    return id
      ? getEntities(entity, EntityTypes.ACTION_ENTITY, 'actionId', id).reduce(
          (prev, ent) => [
            ...prev,
            ...Object.values(assets).filter(
              (asset: IAsset) => asset.entityType === EntityTypes.ACTION_ENTITY && asset.entityId === ent.id,
            ),
          ],
          [],
        )
      : [];
  },
);
